import EraserIcon from './component'

export default EraserIcon
